//Очищает номер телефона от лишних символов
export default {
    methods: {
        isAdmin() {
            try {
                if (!this.$store.getters['authRole']) {
                    throw new Error('Нет данных о правах доступа')
                }
            
                if (this.$store.getters['authRole'].indexOf('ADMIN') < 0) {
                //Если не админ
                    return false
                } else {
                    return true
                }
            } catch (e) {
                console.error(e)
            }
        }
    }
}